import { Configuration } from '@azure/msal-browser';

const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

export const msalConfig: Configuration = {
  auth: {
    clientId: "650ce438-b6ac-40c9-8226-5c8f45213dcf",
    authority: "https://login.microsoftonline.com/5a9d9cfd-c32e-4ac1-a9ed-fe83df4f9e4d",
    redirectUri: isLocalhost ? "http://localhost:8000/" : "https://aicoach.ashley.com/",
  }
};